var cilArrowThickFromBottom = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M256.2,16,56,215.993v38.632H176v144H336v-144H456V216ZM304,222.625v144H208v-144H94.639L256.174,61.254l161.21,161.371Z' class='ci-primary'/><rect width='400' height='32' x='56' y='462.625' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilArrowThickFromBottom };

